import { fixNumber } from "./common";
import { Threshold } from "../../../../../../../../../../../../services/cloudchipr.api";

export const formatThresholds = (thresholds: Threshold[]) => {
  return thresholds.map((th) => ({
    ...th,
    percent: fixNumber(th.percent, 2),
  }));
};
